export default __webpack_public_path__ + "static/media/Facebook_f_logo_(2021).svg.3de22bc3.png";